import "@nutui/nutui/dist/style.css";
import { createApp } from 'vue';
import App from './App.vue';
import axios from 'axios';
import qs from 'qs';
import { Navbar,Grid,BackTop,GridItem,Form,FormItem,Notify,Switch,Radio,
    RadioGroup,DatePicker,Calendar,Picker,Popup,
    Cell,CellGroup,Button,Uploader,Progress,Icon,OverLay,Input   } from "@nutui/nutui";
import "@nutui/nutui/dist/style.css";

//数据请求字符
// axios.defaults.baseURL = 'http://192.168.66.227:9999';
axios.defaults.baseURL = 'https://recruit.sdrenfeng.cn';

// 如果请求话费了超过 `timeout` 的时间，请求将被中断
axios.defaults.timeout = 60000;
// 表示跨域请求时是否需要使用凭证
axios.defaults.withCredentials = false;
// axios.defaults.headers.common['token'] =  AUTH_TOKEN
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';
// 允许跨域
axios.defaults.headers.post["Access-Control-Allow-Origin-Type"] = "*";


const app=createApp(App);
app.config.globalProperties.$api = axios;
app.config.globalProperties.$qs = qs;
app.config.globalProperties.$baseUrl = axios.defaults.baseURL;
app.use(Button);
app.use(Input);
app.use(Uploader);
app.use(Progress);
app.use(BackTop);
app.use(Icon);
app.use(Navbar);
app.use(Grid);
app.use(GridItem);
app.use(Form);
app.use(FormItem);
app.use(Switch);
app.use(Radio);
app.use(Notify);
app.use(RadioGroup);
app.use(DatePicker);
app.use(Calendar);
app.use(Picker);
app.use(Popup);
app.use(Cell);
app.use(Cell);
app.use(CellGroup);
app.use(OverLay);
app.mount("#app");
